export enum NotificationTypeEnum {
    Schedule = 1,
    Request = 2,
    Hospitalization = 3,
    IntegratedSchedule = 4,
}
